
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _4044jEoyhM5D4gpl_RRiBbkgnQzteY7NWoRqojXN9e6aQsMeta } from "/vercel/path0/pages/404.vue?macro=true";
import { default as errorN_45ENTyPlpzPg6hn_0BxpsMhhH7pcBYCZkt9W5qJyQFYMeta } from "/vercel/path0/pages/error.vue?macro=true";
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as logouta5LfroDscl83QSOVnBg1WHUyENO_v5V_454taSGE0odUIMeta } from "/vercel/path0/pages/logout.vue?macro=true";
import { default as _91threadId_93USN_tEvZCTtQowAMDBX84xQMHVB6qyKcAUrqcFuJJg0Meta } from "/vercel/path0/pages/chat/[threadId].vue?macro=true";
export default [
  {
    name: "404",
    path: "/404",
    meta: _4044jEoyhM5D4gpl_RRiBbkgnQzteY7NWoRqojXN9e6aQsMeta || {},
    component: () => import("/vercel/path0/pages/404.vue")
  },
  {
    name: "error",
    path: "/error",
    meta: { ...(errorN_45ENTyPlpzPg6hn_0BxpsMhhH7pcBYCZkt9W5qJyQFYMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/vercel/path0/pages/error.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta || {}), ...{"middleware":["auth","course"]} },
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: logouta5LfroDscl83QSOVnBg1WHUyENO_v5V_454taSGE0odUIMeta || {},
    component: () => import("/vercel/path0/pages/logout.vue")
  },
  {
    name: "chat-threadId",
    path: "/chat/:threadId()",
    meta: { ...(_91threadId_93USN_tEvZCTtQowAMDBX84xQMHVB6qyKcAUrqcFuJJg0Meta || {}), ...{"middleware":["auth","course"]} },
    component: () => import("/vercel/path0/pages/chat/[threadId].vue")
  }
]